import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { CheckCircle as CheckIcon, Print as PrintIcon } from "@mui/icons-material";
import { petpooja } from "../posPetpoojaTheme";

interface KOTDialogProps {
  open: boolean;
  kotNumber?: string | null;
  tableName?: string;
  onClose: () => void;
}

const KOTDialog: React.FC<KOTDialogProps> = ({
  open,
  kotNumber,
  tableName,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          bgcolor: petpooja.greenDark,
          color: "#fff",
          py: 2,
        }}
      >
        <CheckIcon sx={{ fontSize: 48, mb: 0.5 }} />
        <Typography variant="h6" fontWeight={800}>
          KOT Sent to Kitchen
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", py: 3 }}>
        {kotNumber && (
          <Box
            sx={{
              display: "inline-block",
              px: 3,
              py: 1.5,
              bgcolor: petpooja.bg,
              borderRadius: 2,
              border: `2px dashed ${petpooja.accent}`,
              mb: 2,
            }}
          >
            <Typography variant="caption" color={petpooja.textMuted} display="block">
              KOT Number
            </Typography>
            <Typography variant="h5" fontWeight={800} color={petpooja.accent}>
              {kotNumber}
            </Typography>
          </Box>
        )}
        {tableName && (
          <Typography variant="body2" color={petpooja.textMuted}>
            Table: <strong>{tableName}</strong>
          </Typography>
        )}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mt: 1 }}>
          <PrintIcon sx={{ fontSize: 16, color: petpooja.textMuted }} />
          <Typography variant="caption" color={petpooja.textMuted}>
            Order sent to kitchen display
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2.5, px: 2 }}>
        <Button
          variant="contained"
          fullWidth
          onClick={onClose}
          sx={{
            bgcolor: petpooja.accent,
            fontWeight: 700,
            py: 1.25,
            "&:hover": { bgcolor: petpooja.accentDark },
          }}
        >
          Continue Billing
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KOTDialog;
